/* src/app/shared/components/controls/multi-select-grid/multi-select-grid.component.scss */
.loader-container {
  position: relative;
  height: 200px;
  width: 450px;
  margin-top: -10px;
  overflow: hidden;
  background-color: #ffffff;
}
.alert {
  font-size: 18px;
  padding-top: 1%;
  height: 20px;
  width: 20px;
  top: 6px;
  position: relative;
}
.info {
  font-size: 17px;
  height: 17px;
  width: 17px;
  padding-top: 1px;
}
.grid-container {
  margin-top: -12px;
}
.grid-container .search-container {
  width: 100%;
}
.grid-container .search-container app-common-search {
  display: block;
  width: 100%;
}
.grid-container .grid-item-container {
  max-height: 300px;
  overflow-x: auto;
  margin-bottom: 12px;
}
.grid-container .row-content {
  padding: 12px;
}
.grid-container .row-content .content-header {
  width: 100%;
  padding: 6px;
  background-color: #EBECED;
  display: flex;
  align-items: center;
}
.grid-container .row-content .content-item {
  width: 100%;
  padding: 6px 6px 6px 12px;
}
.grid-container .row-content .no-content {
  padding: 6px;
}
.grid-container .row-content .content-item:nth-child(even) {
  background-color: #F9F9F9;
}
.grid-container .row-content .content-item:nth-child(odd) {
  background-color: #ffffff;
}
.grid-container .grid-item:nth-child(even) {
  background-color: #F9F9F9;
}
.grid-container .grid-item:nth-child(odd) {
  background-color: #ffffff;
}
.accordion-toggle-btn {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  padding: 0;
  margin-right: 8px;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: 15px;
  position: relative;
}
.accordion-toggle-icon {
  width: 14px;
  height: 14px;
  display: block;
  background-image: url(/assets/images/accordion-collapsed.svg);
  background-repeat: no-repeat;
  background-size: 14px 14px;
  background-position: center;
}
.accordion-toggle-btn:hover .accordion-toggle-icon:not(.is-expanded) {
  background-image: url(/assets/images/accordian-collpased-hover.svg);
}
.accordion-toggle-icon.is-expanded {
  background-image: url(/assets/images/accordion-down-enable.svg);
}
.no-result-message {
  font-family: Lato !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  color: var(--light-grey);
  text-align: center;
  margin: 24px 0px 0px;
}
:host ::ng-deep .search-container .common-search-field {
  margin-bottom: 0;
}
:host ::ng-deep .search-container .common-search-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .search-container .common-search-field .mat-mdc-text-field-wrapper {
  padding: 0;
  border-bottom: 1px solid var(--lighter-grey);
  border-radius: 0;
}
:host ::ng-deep .search-container .common-search-field .mdc-notched-outline {
  display: none;
}
.tag-name-ctnr {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.restricted-row,
.restricted-row .row-checkbox,
.restricted-row .row-checkbox .mdc-form-field,
.restricted-row .row-checkbox .mdc-label {
  cursor: not-allowed;
}
:host ::ng-deep .restricted-row .row-checkbox .mdc-checkbox__background,
:host ::ng-deep .restricted-row .row-checkbox .mat-mdc-checkbox-touch-target,
:host ::ng-deep .restricted-row .row-checkbox .mat-mdc-checkbox-ripple {
  cursor: not-allowed;
}
/*# sourceMappingURL=multi-select-grid.component-OC2HV2GE.css.map */
